import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        languages: [
            {
                src: "norway-flag-icon-64.png",
                long: "Norsk",
                short: "NO",
            },
            {
                src: "united-kingdom-flag-icon-64.png",
                long: "English",
                short: "EN",
            }
        ],
        selectedLanguage: undefined
    },
    getters: {
        languages: (state) => { return state.languages; },
        selectedLanguage: (state) => { return state.selectedLanguage; },
    },
    mutations: {
        selectedLanguage: function(state, language) {
            state.selectedLanguage = language;
        }
    },
    actions: {
    },
    modules: {
    }
})
